import React, { useState } from 'react';
import ApartmentService from '../../../services/ApartmentService';
function CreateApartmentComponent() {
    const [createNewApartment, setCreateNewApartment] = useState(false);
    const [newApartment, setNewApartment] = useState({});

    const createNewApartmentClick = () => {
        if (createNewApartment) {
            setCreateNewApartment(false);
            setNewApartment({});
        }
        else {
            setCreateNewApartment(true);
            setNewApartment({});
        }
    };

    const createNewApartmentSubmit = (e) => {
        // lets not submit the form.
        e.preventDefault();

        // because we are in this component we know that we are creating a new apartment.
        ApartmentService
            .newApartment(newApartment)
            .catch(function (err) {
                alert("Der opstod en fejl");
                console.log("Error saving", err);
            });

        // Reset state
        setCreateNewApartment(false);
        setNewApartment({});

        return;
    };

    return (
        <div className="col-md">
            {createNewApartment ?
                <form className="apartmentForm " id="apartmentForm" onSubmit={createNewApartmentSubmit} >
                    <table id="apartmentEdit" className="table table-responsive"><tbody>
                        <tr>
                            <td>
                                <label>Andels nr.</label><br />
                                <input className='form-control' type="text" value={newApartment.number || ''} onChange={(event) => setNewApartment({ ...newApartment, number: event.target.value })} />
                            </td>
                            <td>
                                <label>Adresse</label><br />
                                <input className='form-control' type="text" value={newApartment.address || ''} onChange={(event) => setNewApartment({ ...newApartment, address: event.target.value })} />
                            </td>
                            <td>
                                <label>Postnummer</label><br />
                                <input className='form-control' type="text" value={newApartment.postcode || ''} onChange={(event) => setNewApartment({ ...newApartment, postcode: event.target.value })} />
                            </td>
                            <td>
                                <label>By</label><br />
                                <input className='form-control' type="text" value={newApartment.suburb || ''} onChange={(event) => setNewApartment({ ...newApartment, suburb: event.target.value })} />
                            </td>
                            <td>
                                <label>Type</label><br />
                                <input className='form-control' type="text" value={newApartment.type || ''} onChange={(event) => setNewApartment({ ...newApartment, type: event.target.value })} />
                            </td>
                            <td>
                                <label>Størrelse</label><br />
                                <input className='form-control' type="text" value={newApartment.sqm || ''} onChange={(event) => setNewApartment({ ...newApartment, sqm: event.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td >
                                <label>Have?</label><br />
                                <input className='' type="checkbox" checked={newApartment.garden || false} onChange={(event) => setNewApartment({ ...newApartment, garden: event.target.checked })} />
                            </td>
                            <td >
                                <label>Altan?</label><br />
                                <input className='' type="checkbox" checked={newApartment.balcony || false} onChange={(event) => setNewApartment({ ...newApartment, balcony: event.target.checked })} />
                            </td>
                            <td >
                                <label>Kælderrum</label><br />
                                <input className='form-control' type="text" value={newApartment.basement || ''} onChange={(event) => setNewApartment({ ...newApartment, basement: event.target.value })} />
                            </td>
                            <td >
                                <label>Loftrum</label><br />
                                <input className='form-control' type="text" value={newApartment.attic || ''} onChange={(event) => setNewApartment({ ...newApartment, attic: event.target.value })} />
                            </td>
                            <td >
                                <label>Boligafgift 1</label><br />
                                <input className='form-control' type="text" value={newApartment.apartmentFee || ''} onChange={(event) => setNewApartment({ ...newApartment, apartmentFee: event.target.value })} />
                            </td>

                            <td >
                                <label>Aconto varme</label><br />
                                <input className='form-control' type="text" value={newApartment.acontoheat || ''} onChange={(event) => setNewApartment({ ...newApartment, acontoheat: event.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td >
                                <label>Varmehaner</label><br />
                                <input className='form-control' type="text" value={newApartment.heathose || ''} onChange={(event) => setNewApartment({ ...newApartment, heathose: event.target.value })} />
                            </td>
                            <td >
                                <label>Vinduefang</label><br />
                                <input className='form-control' type="text" value={newApartment.vinduefang || ''} onChange={(event) => setNewApartment({ ...newApartment, vinduefang: event.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td >
                                <label>Andelskroner</label><br />
                                <input className='form-control' type="text" value={newApartment.andelskroner || ''} onChange={(event) => setNewApartment({ ...newApartment, andelskroner: event.target.value })} />
                            </td>
                            <td >
                                <label>Erhverv?</label><br />
                                <input className='' type="checkbox" checked={newApartment.company || false} onChange={(event) => setNewApartment({ ...newApartment, company: event.target.checked })} />
                            </td>
                            <td colSpan="2">
                                <label>Noter</label><br />
                                <input className='form-control' type="text" value={newApartment.note || ''} onChange={(event) => setNewApartment({ ...newApartment, note: event.target.value })} />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                                <button className="btn btn-primary" onClick={createNewApartmentClick}>Afbryd</button>
                            </td>
                            <td>
                                <button type="submit" className="btn btn-primary" >Opret</button>
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </form> :
                <div className='midButtonWithPadding'><button className="btn btn-primary" onClick={createNewApartmentClick}>Opret ny lejlighed</button></div>}
        </div>
    );
}

export default CreateApartmentComponent;